































































import Vue from "vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import configuration from "@/models/Configuration";
import { roundMoney } from "@/services/prices";
import store, { InvoiceItemStore } from "../services/store";
import { InvoiceItem, InvoiceItemType } from "../models";

interface StockItemGroup {
  key: string;
  name: string;
  netto: number;
  quantity: number;
  taxName: string;
  unitPrice: number;
  vat: number;
  brutto: number;
  unit: string;
  currency: string;
}

interface Data {
  store: InvoiceItemStore;
}

interface Computed {
  groups: StockItemGroup[];
}

interface Methods {
  getGeniDigits(currency: string): number;
  getGeniUnitDigits(currency: string): number;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    MoneyDisplay,
  },

  data: () => ({
    store,
  }),

  computed: {
    // a készletes tételeket cikk, egységár és áfa kulcs szerint vonjuk össze
    groups() {
      const groups = new Map<string, StockItemGroup>();

      (this.store.itemList.items as InvoiceItem[])
        .filter((item) => item.type === InvoiceItemType.Stocked)
        .forEach((item) => {
          const key = `${item.productID}|${item.unitPrice}|${item.tax?.id ?? 1}`;

          const group = groups.get(key) ?? {
            key,
            name: item.itemName,
            netto: 0,
            quantity: 0,
            taxName: item.tax?.vatDisplayName || item.tax?.name || "-",
            unitPrice: item.unitPrice,
            vat: 0,
            brutto: 0,
            unit: item.unit?.name ?? "-",
            currency: item.currency,
          };

          group.netto += item.nettoValue;
          group.quantity += item.quantity;
          group.vat += item.taxValue;
          group.brutto += item.bruttoValue;

          groups.set(key, group);
        });

      // az összegzés lebegőpontos maradékát levágjuk
      return [...groups.values()].map((group) => ({
        ...group,
        netto: roundMoney(group.netto, group.currency),
        vat: roundMoney(group.vat, group.currency),
        brutto: roundMoney(group.brutto, group.currency),
        quantity: Number(group.quantity.toFixed(6)),
      }));
    },
  },

  methods: {
    getGeniDigits(currency) {
      return configuration.operel ? 2 : configuration.getCurrDigits(currency)?.geniDigits ?? 0;
    },

    getGeniUnitDigits(currency) {
      return configuration.operel ? 2 : configuration.getCurrDigits(currency)?.geniUnitDigits ?? 0;
    },
  },
});
